// Import dependencies
import React, {Component} from 'react';
import hoverEffect from 'hover-effect'
import $ from 'jquery';

// Import css
import './CityDistortion.css';

// Import images
import city from "../../resources/images/landing/city-mobile.png";
import cityTr from "../../resources/images/landing/city-mobile-transparent.png";
import displacement from "../../resources/images/displacement/mask.jpg";

// Initialize distortion animation
let myAnimation;

// Variable to check if document opened first time
let margin = 10;

export default class CityDistortionMobile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            width: 0,
            height: 0
        };
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    }

    // Updates window dimensions on window resize event
    updateWindowDimensions() {
        let height = window.innerHeight;
        let width = window.innerWidth;
        let start = height*.6*.9576;
        this.setState({ width: width, height: window.height });

        let percent = ((width - start) * 100) / (770 - start);

        if($('.cd__container').innerHeight()/height > .6) {
            let result = ((percent * (-50 - 10) / 100) +10);
            margin = result;
        }
        else {
            margin = 10;
        }
    }

    // Toggles WEBGL animation
    showCity() {
        myAnimation.next()
    }
    hideCity() {
        myAnimation.previous()
    }

    componentDidMount() {
        // Set window resize listener
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);

        // Initialize animation
        setTimeout(function () {
            myAnimation = new hoverEffect({
                parent: document.querySelector('.cd__container'),
                intensity: .7,
                image1: cityTr,
                image2: city,
                displacementImage: displacement,
                hover: false,
                speedIn: 1.3,
                speedOut: 2,
                easing: 'cubic-bezier(.75,0,.25,1)',
                angle: 3.92699
            });
        }, 10);

        setTimeout(this.updateWindowDimensions, 50);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }

    render() {
        return (
            <div
                className='cd__container'
                style={{
                    height: this.state.width*1.0442,
                    width: this.state.width,
                    top: margin+'%'
                }}
                ref={element => this.iconRef = element}
            >
                <div className='cd__mobile-background' />
            </div>
        );
    }
}
